import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { PatientWorkflow } from './patient-workflow.model';

export enum PatientWorkflowActionTypes {
  LoadPatientWorkflows = '[PatientWorkflow] Load PatientWorkflows',
  AddPatientWorkflow = '[PatientWorkflow] Add PatientWorkflow',
  UpsertPatientWorkflow = '[PatientWorkflow] Upsert PatientWorkflow',
  AddPatientWorkflows = '[PatientWorkflow] Add PatientWorkflows',
  UpsertPatientWorkflows = '[PatientWorkflow] Upsert PatientWorkflows',
  UpdatePatientWorkflow = '[PatientWorkflow] Update PatientWorkflow',
  UpdatePatientWorkflows = '[PatientWorkflow] Update PatientWorkflows',
  DeletePatientWorkflow = '[PatientWorkflow] Delete PatientWorkflow',
  DeletePatientWorkflows = '[PatientWorkflow] Delete PatientWorkflows',
  ClearPatientWorkflows = '[PatientWorkflow] Clear PatientWorkflows',
}

export class LoadPatientWorkflows implements Action {
  readonly type = PatientWorkflowActionTypes.LoadPatientWorkflows;

  constructor(public payload: { patientWorkflows: PatientWorkflow[] }) {}
}

export class AddPatientWorkflow implements Action {
  readonly type = PatientWorkflowActionTypes.AddPatientWorkflow;

  constructor(public payload: { patientWorkflow: PatientWorkflow }) {}
}

export class UpsertPatientWorkflow implements Action {
  readonly type = PatientWorkflowActionTypes.UpsertPatientWorkflow;

  constructor(public payload: { patientWorkflow: PatientWorkflow }) {}
}

export class AddPatientWorkflows implements Action {
  readonly type = PatientWorkflowActionTypes.AddPatientWorkflows;

  constructor(public payload: { patientWorkflows: PatientWorkflow[] }) {}
}

export class UpsertPatientWorkflows implements Action {
  readonly type = PatientWorkflowActionTypes.UpsertPatientWorkflows;

  constructor(public payload: { patientWorkflows: PatientWorkflow[] }) {}
}

export class UpdatePatientWorkflow implements Action {
  readonly type = PatientWorkflowActionTypes.UpdatePatientWorkflow;

  constructor(public payload: { patientWorkflow: Update<PatientWorkflow> }) {}
}

export class UpdatePatientWorkflows implements Action {
  readonly type = PatientWorkflowActionTypes.UpdatePatientWorkflows;

  constructor(public payload: { patientWorkflows: Update<PatientWorkflow>[] }) {}
}

export class DeletePatientWorkflow implements Action {
  readonly type = PatientWorkflowActionTypes.DeletePatientWorkflow;
  constructor(public payload: { id: string }) {}
}

export class DeletePatientWorkflows implements Action {
  readonly type = PatientWorkflowActionTypes.DeletePatientWorkflows;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearPatientWorkflows implements Action {
  readonly type = PatientWorkflowActionTypes.ClearPatientWorkflows;
}

export type PatientWorkflowActions =
  | LoadPatientWorkflows
  | AddPatientWorkflow
  | UpsertPatientWorkflow
  | AddPatientWorkflows
  | UpsertPatientWorkflows
  | UpdatePatientWorkflow
  | UpdatePatientWorkflows
  | DeletePatientWorkflow
  | DeletePatientWorkflows
  | ClearPatientWorkflows;
